import React, { useState } from 'react'
import { useReactOidc } from '@axa-fr/react-oidc-context'
import Header from '../components/Header'

const HeaderContainer = props => {
    const { oidcUser: { profile }, logout } = useReactOidc()
    const [showMenu, setShowMenu] = useState(false)

    return (
        <Header
            toggleMenu={() => setShowMenu(!showMenu)}
            closeMenu={() => setShowMenu(false)}
            displayName={profile.name}
            isActive={showMenu}
            navigationItems={[]}
            logout={logout}
            search={props.search}
        />
    )
}

export default HeaderContainer
